import Banner from "../Components/Shared/Layout/Banner";
import withLanguage from "../HOC/withLanguage";
import React from "react";

const LegalBase = ({ language }) => {
    return (
        <>
            <h1 className="text-3xl font-bold text-center mt-4 text-red-600">{language.banner}</h1>
            <div className="m-5 xl:mx-[15rem] lg:mx-[7rem] md:mx-[3rem] xs:mx-[2.5rem]">
                <p className="text-lg py-3 text-justify">{language.p1}</p>

                <p className="text-lg py-3 font-bold">{language.contractModel}</p>
                <p className="text-lg py-1 font-bold">{language.cooperationModel}</p>

                <h2 className="text-2xl font-bold mt-6 mb-2">{language.criteriaEmployerTitle}</h2>
                <ul className="list-disc list-inside space-y-2">
                    {language.criteriaEmployer?.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>

                <h2 className="text-2xl font-bold mt-6 mb-2">{language.criteriaStudentTitle}</h2>
                <ul className="list-disc list-inside space-y-2">
                    {language.criteriaStudent?.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>

                <h2 className="text-2xl font-bold mt-6 mb-2">{language.criteriaIoAFPTitle}</h2>
                <ul className="list-disc list-inside space-y-2">
                    {language.criteriaIoAFP?.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>
            </div>
        </>
    );
};

export default withLanguage(LegalBase, "LegalBase");
